module.exports = __webpack_public_path__ + "img/test-mode4.38ac7271.png";